var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    transform: "matrix(-1 0 0 1 36 0)",
    fill: "#7927FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6124 21.7501C22.8707 22.8601 21.8165 23.7253 20.5831 24.2362C19.3497 24.7471 17.9925 24.8808 16.6831 24.6203C15.3738 24.3599 14.171 23.717 13.227 22.773C12.283 21.829 11.6401 20.6262 11.3797 19.3169C11.1192 18.0075 11.2529 16.6503 11.7638 15.4169C12.2747 14.1835 13.1399 13.1293 14.2499 12.3876C15.3599 11.6459 16.665 11.25 18 11.25C19.887 11.2571 21.6983 11.9934 23.055 13.305L24.75 15M21 15H24.75V11.25",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/Resend.9b00064fec314bdf9a7d85b4f927bc81.svg";
export { ForwardRef as ReactComponent };